<template>
  <div class="orders-list">
    <base-heading>{{ $t('standingOrder.ordersTitle') }}</base-heading>
    <p class="description" v-html="$t('standingOrder.orderList.description')"></p>

    <div v-for="(order, index) in $props.ordersList"
         :key="'order'+index"
         class="single-order">
      <div class="data-wrapper">
        <div v-for="(cell, idx) in cardColumns"
             :key="'cell'+index+idx"
             class="data-cell">
          <div>
            <p class="cell-label">{{ cell.label }}</p>
            <template v-if="cell.name === 'contract'">
              <h5 class="cell-title">{{ order.subscriptionInfo.description }}</h5>
              <p class="cell-description">{{ `${order.subscriptionInfo.firstName} ${order.subscriptionInfo.lastName || ''}` }}</p>
            </template>
            <template v-if="cell.name === 'dueDate'">
              <h5 class="cell-title">{{ `${order.standingOrder.dateOfPayment}. ${$t('standingOrder.orderList.inMonthLabel')}` }}</h5>
            </template>
            <template v-if="cell.name === 'limit'">
              <h5 class="cell-title">{{ order.standingOrder.limitAmount ? order.standingOrder.limitAmount.formattedValue : '/' }}</h5>
            </template>
            <template v-if="cell.name === 'paymentCard'">
              <h5 class="cell-title">{{ order.standingOrder.card ? `${capitalizeString(order.standingOrder.card.type)} ${shortCardNumber(order.standingOrder.card.cardNumber)}` : '-' }}</h5>
            </template>
          </div>
        </div>
      </div>
      <div class="actions-wrapper">
        <base-button variant="text"
                     class="action-button"
                     @click="emitEditEvent(order)">
          <i class="icon-sc-edit"></i>
        </base-button>
        <base-button variant="text"
                     class="action-button"
                     @click="emitDeleteEvent(order.standingOrder.code)">
          <i class="icon-sc-delete"></i>
        </base-button>
      </div>
    </div>

    <base-button variant="primary"
                 class="add-order-btn"
                 :disabled="!$props.customerList.length"
                 @click="emitCreateNewAccount">
      {{ $t('standingOrder.orderList.addOrderLabel') }}
    </base-button>
  </div>
</template>

<script>
export default {
  name: 'so-orders-list',
  props: {
    ordersList: {
      type: Array,
      default: () => []
    },
    customerList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    cardColumns () {
      return Object.freeze([
        {
          name: 'contract',
          label: this.$t('standingOrder.orderList.contractLabel')
        },
        {
          name: 'dueDate',
          label: this.$t('standingOrder.orderList.dueDateLabel')
        },
        {
          name: 'limit',
          label: this.$t('standingOrder.orderList.limitLabel')
        },
        {
          name: 'paymentCard',
          label: this.$t('standingOrder.orderList.paymentCardLabel')
        }
      ])
    }
  },
  methods: {
    capitalizeString (value) {
      if (!value) return ''
      return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    },
    shortCardNumber (value) {
      if (!value) return ''
      return value.slice(-8)
    },
    emitCreateNewAccount () {
      this.$emit('add-new-order')
    },
    emitEditEvent (data) {
      this.$emit('edit-order', data)
    },
    emitDeleteEvent (code) {
      this.$emit('delete-order', code)
    }
  }
}
</script>

<style scoped lang="scss" src="./styles/so-orders-list.scss"></style>
